import CoreApp from "./core/coreApp";
import LazyDisp from "./components/lazydisp";
import FloatCtaFooterHide from "./components/floatCtaFooterHide";

const [d] = [document];

export default class CUSTOMIZE extends CoreApp {

  constructor(opt) {
    opt = Object.assign({
      // header: '.site-header',
      // pagetop: '.c-pagetop'
      // fixNavを指定すると、スクロール時に固定するクラスを付与する
      // fixNav : '[data-role="fixNav"]',
    },opt);

    // 上位クラスのコンストラクタ呼び出し
    super(opt);

    this.toggleTags();
    this.customInit();
  }

  customInit() {

    // イベント一覧
    d.addEventListener('app.beforeInit', () => false );
    d.addEventListener('app.beforeDomready', () => false );
    d.addEventListener('app.beforeWindowload', () => false );
    d.addEventListener('app.zip2addr', () => false );
    d.addEventListener('Scroll.beforeInit', () => false );
    d.addEventListener('Scroll.scrollUp', () => false );
    d.addEventListener('Scroll.scrollDown', () => false );
    d.addEventListener('Lazydisp.beforeInit', () => false );

    // テンプレートインスタンスのプロミス
    this.promises.init.then( () => false );
    this.promises.domReady.then( () => false );
    this.promises.windowLoad.then( () => false );

    // テンプレートインスタンスの全非同期メソッドの完了時に実行
    this.promiseAll().then( () => false );

    $(() => {
      // htmlデータ読み込み
      $('[data-load-html]').loadHtml();

      // カレントメニュー
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});

      Promise.all([window.load['loadHtml']]).then(() => this.hashscroll());
      Promise.all([window.load['loadHtml']]).then(() => new LazyDisp('[data-lazydisp]'));

      // フッターお問い合わせ付近で追従CTAをフェードアウト（メイン・マルチ共通）
      new FloatCtaFooterHide();
    });
  }

  loading() {
    d.documentElement.classList.add( this.opt.loadingClass );
    d.documentElement.classList.add( 'is-pageload-available' );
    d.addEventListener('DOMContentLoaded', () => {
      d.documentElement.classList.remove( this.opt.loadingClass );
      d.documentElement.style.opacity = '';
    });
  }
  
  // タグ・キーワードの全て表示
  toggleTags() {
    const buttons = document.querySelectorAll('.toggle_btn');
    buttons.forEach(button => {
      button.addEventListener('click', (event) => {
        const clickedButton = event.currentTarget;
        const targetId = clickedButton.dataset.toggleId;
        if (!targetId) return;
        const targetGroup = document.querySelector(`[data-target="${targetId}"]`);
        if (targetGroup) {
          targetGroup.classList.toggle('is-active');
          clickedButton.classList.toggle('is-active');
          const isNowActive = clickedButton.classList.contains('is-active');
          if (isNowActive) {
            clickedButton.textContent = clickedButton.dataset.hideText;
          } else {
            clickedButton.textContent = clickedButton.dataset.showText;
          }
        }
      });
    });
  }
}

window.WebFontConfig = {
  google: {
    families: ['Roboto:200,400,500,600', 'Mulish:300,400,600,700', 'Figtree:600', 'League+Spartan:300', 'Cantarell:700', 'Jost:500', 'Zen+Maru+Gothic:700', 'Noto+Sans+JP:300,400,500,700,900&subset=japanese']
  },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();